<template>
  <div>
    <search-list @findData="findData" ></search-list>
    <div class="flex mb16" style="padding: 0 24px;">
      <div class="over-item">
        <span>待商家确认:</span>
        <span class="text-red">￥{{unConfirmSumAmount}}</span>
      </div>
      <div class="over-item">
        <span>已确认:</span>
        <span class="text-red">￥{{confirmSumAmount}}</span>
      </div>
    </div>
    <div class="page-wrapper">
      <Button type="primary" class="mb16" @click.stop="exportConfirmOrderList" v-p="{api:'contractConfirmOrder/downloadOrderList'}" :loading = "btnLoading">导出</Button>
      <br>
      <table-list
        :columns="columns"
        :data="dataTable"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
    </div>
    <modify-confirm-order-form   :n = "modifyConfirmOrderKey"  :confirmOrderFid="confirmOrderFid" @refresh="findData(searched)"></modify-confirm-order-form>
    <view-confirm-order-form   :n = "viewConfirmOrderKey"  :confirmOrderFid="confirmOrderFid"></view-confirm-order-form>
  </div>
</template>
<script>
  import SearchList from './components/SearchList';
  import TableList from 'components/TableList/index';
  import {formatDateTime} from '@/utils/format';
  import {confirmOperate,delOperate,confirmOrderList,getSumAmountOrder,exportOrderCount,downloadOrderList} from "../../api/confirmOrder";
  import ModifyConfirmOrderForm from './components/ModifyConfirmOrderForm';
  import ViewConfirmOrderForm from './components/ViewConfirmOrderForm';
  import {validateAndDownload} from '@/utils/public'
  export default {
    name: "confirmOrder",
    created() {
      this.findData()
    },
    components:{
      SearchList,
      TableList,
      ModifyConfirmOrderForm,
      ViewConfirmOrderForm
    },

    data(){
      return {
        page:1,
        current: 1,
        total: 0,
        dataTable: [],
        loading: false,
        modifyConfirmOrderKey:0,
        viewConfirmOrderKey:0,
        confirmOrderFid:'',
        unConfirmSumAmount:0,
        confirmSumAmount:0,
        btnLoading:false,
        searchData: {
          page: 1,
          limit: 10
        },
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title:'确认单编号',
            key:'confirmOrderCode',
            align:'center',
            width:160
          },
          {
            title:' '
          },
          {
            title:'项目名称',
            key:'projectName',
            align:'center',
            width:160
          },
          {
            title:' '
          },
          {
            title:'房间/床位号',
            key:'stockNum',
            align:'center',
            width:160
          },
          {
            title:' '
          },
          {
            title:'客户名称',
            key:'customerName',
            align:'center',
            width:220
          },
          {
            title:' '
          },
          {
            title:'客户手机号',
            key:'customerPhone',
            align:'center',
            width:120
          },
          {
            title:' '
          },
          {
            title:'合同号',
            key:'contractCode',
            align:'center',
            width:180
          },
          {
            title:' '
          },
          {
            title:'平台服务费',
            key:'servicePrice',
            align:'center',
            width:180
          },
          {
            title:' '
          },
          {
            title:'月租金',
            key:'monthPrice',
            align:'center',
            width:80
          },
          {
            title:' '
          },
          {
            title:'总租金',
            key:'totalPrice',
            align:'center',
            width:80
          },
          {
            title:' '
          },
          {
            title:'合同起租日',
            key:'conStartDate',
            align:'center',
            width:120
          },
          {
            title:' '
          },
          {
            title:'合同到期日',
            key:'conEndDate',
            align:'center',
            width:120
          },
          {
            title:' '
          },
          {
            title:'合同签约日',
            key:'conSignDate',
            align:'center',
            width:120
          },
          {
            title:' '
          },
          {
            title:'签约人',
            key:'zoName',
            align:'center',
            width:100
          },
          {
            title:' '
          },
          {
            title:'状态',
            key:'statusName',
            align:'center',
            width:100
          },
          {
            title:' '
          },
          {
            title:'创建时间',
            key:'createTime',
            align:'center',
            width:180
          },
          {
            title:' '
          },
          {
            title:'确认时间',
            key:'confirmTime',
            align:'center',
            width:180
          },
          {
            title:' '
          },
          {
            title:'确认人',
            key:'confirmedBy',
            align:'center',
            width:100
          },
          {
            title:' '
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            fixed: 'right',
            width: 180,
            render: (h, params) => {
              return h('div',[h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'contractConfirmOrder/confirmOperate'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.status!=1 ? 'none' :'inline-block'
                },
                on:{
                  click: () => {
                    this.confirmOrderFid = params.row.fid;
                    this.confirmOperate(params);
                  }
                }
              },'确认'),h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'contractConfirmOrder/addOrUpdate'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.status==2 ? 'none' :'inline-block'
                },
                on:{
                  click: () => {
                    this.modifyConfirmOrderKey++;
                    this.confirmOrderFid = params.row.fid
                  }
                }
              },'修改'),h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'contractConfirmOrder/delOperate'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.status==2 ? 'none' :'inline-block'
                },
                on:{
                  click: () => {
                    this.confirmOrderFid = params.row.fid
                    this.delOperate(params);
                  }
                }
              },'刪除'),h('a',{
                style: {
                  marginRight: '5px'
                },
                on:{
                  click: () => {
                    this.viewConfirmOrderKey++;
                    this.confirmOrderFid = params.row.fid
                  }
                }
              },'查看')])

            }
          },

        ],
        searched:null,
      }

    },
    methods:{
      findData(data){
        this.page=1;
        this.current=1;
        this.confirmOrderList(data);
        this.getSumAmountOrder(data);
      },
      confirmOrderList(data){

        let params={
          ...data,
          page:this.page,
          limit:10
        };
        confirmOrderList(params).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows;
          this.total=res.data.total;
          this.searched=params
        }).catch(error=>{})
      },

      getSumAmountOrder(data){
        let params={
          ...data,
          page:this.page,
          limit:10
        };
        getSumAmountOrder(params).then(res=>{
          if(!res.data){
            return
          }
          this.unConfirmSumAmount=res.data.unConfirmSumPrice;
          this.confirmSumAmount=res.data.confirmSumPrice;
          this.searched=params
        }).catch(error=>{})
      },

      confirmOperate(params){

        this.$Modal.confirm({
          title: '确认成交确认单',
          content: '<p>确认要对该合同信息进行确认吗？确认后无法撤销</p>',
          onOk: () => {
            var param={
              "fid": params.row.fid,
              "businessFid":params.row.businessFid,
              "status":2
            }
            confirmOperate(param).then(res => {
              this.$Message.success('已确认')
              this.confirmOrderList(this.searched);
              this.getSumAmountOrder(this.searched);
            }).catch(error=>{})
          }
        })
      },

      delOperate(params){
        this.$Modal.confirm({
          title: '删除成交确认单',
          content: '<p>确定要删除该成交确认单吗？</p>',
          onOk: () => {
            var param={
              "fid":params.row.fid,
              "businessFid":params.row.businessFid,
              "isDel":1
            }
            delOperate(param).then(res => {
              this.$Message.success('删除成功')
              this.confirmOrderList(this.searched);
              this.getSumAmountOrder(this.searched);
            }).catch(error=>{})
          }
        })
      },

      changePage(n){
        this.current = n;
        this.page = n;
        this.confirmOrderList(this.searched)

      },
      exportConfirmOrderList(){
        exportOrderCount(this.searched).then( res => {
          if(res.data > 10000){
            this.$Modal.info({
              title: '导出出房确认单',
              content:'上限10000条，请选择条件后下载'
            });
          } else {
            this.btnLoading = true
            validateAndDownload(null,downloadOrderList,this.searched).catch(error=>{
                console.log('导出异常')
            }).finally(()=>{
              this.btnLoading = false
            })
          }

        })

      },

    }
  }
</script>

<style scoped>
  .over-item{
    width: 180px;
  }
</style>
